import LegalPageLayout from '@/components/LegalPageLayout';

export default function TermsPage() {
  return (
    <LegalPageLayout
      testId="terms-page"
      title="Terms & Conditions"
      subtitle="The terms that govern your use of the Peak 9 website and services."
      lastUpdated="August 2026"
    >
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using the Peak 9 website ("Site"), including our keynotes, workshops, coaching
        programs, the "Performance by Design" course, the "1% Gap Diagnostic" quiz, and the Peak 9 Library,
        you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the Site.
      </p>

      <h2>2. Description of Services</h2>
      <p>
        Peak 9 provides keynotes, corporate workshops, coach training ("School of Shayamal"), an online
        performance course, a self-assessment diagnostic quiz, and related content and resources aimed at
        helping individuals and teams improve performance and well-being.
      </p>

      <h2>3. Eligibility</h2>
      <p>Our services are intended for individuals aged 18 or older, or organisations acting through authorised representatives.</p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Site for any unlawful purpose or in violation of these Terms</li>
        <li>Attempt to gain unauthorised access to our systems, data, or accounts of other users</li>
        <li>Copy, resell, or redistribute our content without written permission</li>
        <li>Interfere with the security or proper functioning of the Site</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>
        All content on this Site — including text, graphics, course materials, frameworks, the "1% Gap
        Diagnostic" methodology, and branding — is the property of Peak 9 or its licensors and is
        protected by applicable intellectual property laws. No content may be reproduced or used
        commercially without prior written consent.
      </p>

      <h2>6. Course & Program Enrolment</h2>
      <p>
        Enrolment in the "Performance by Design" course or any paid program is subject to separate
        payment, cancellation, and refund terms communicated to you at the time of purchase or enrolment.
        Access to purchased content is for your personal/organisational use only and may not be shared or
        redistributed.
      </p>

      <h2>7. Diagnostic Quiz Disclaimer</h2>
      <p>
        The "1% Gap Diagnostic" and any results, scores, or reports it generates are provided for general
        informational and self-reflection purposes only. They do not constitute medical, psychological,
        legal, or professional advice, and should not be relied upon as a substitute for professional
        consultation.
      </p>

      <h2>8. Third-Party Links & Services</h2>
      <p>
        The Site may link to or embed third-party services (e.g. Tally.so forms, Google Calendar). Peak 9
        is not responsible for the content, policies, or practices of these third parties.
      </p>

      <h2>9. Disclaimer of Warranties</h2>
      <p>
        The Site and its content are provided "as is" and "as available" without warranties of any kind,
        express or implied, to the fullest extent permitted by law.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Peak 9 shall not be liable for any indirect, incidental,
        or consequential damages arising from your use of the Site or reliance on any content or
        diagnostic results provided through it.
      </p>

      <h2>11. Indemnification</h2>
      <p>You agree to indemnify and hold Peak 9 harmless from any claims arising out of your misuse of the Site or violation of these Terms.</p>

      <h2>12. Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes arising from these Terms or your use
        of the Site shall be subject to the exclusive jurisdiction of the courts of Mumbai, India, without
        prejudice to any statutory rights you may have under the laws of the EU/UK or your place of
        residence where mandatorily applicable.
      </p>

      <h2>13. Changes to These Terms</h2>
      <p>We may revise these Terms from time to time. Continued use of the Site after changes constitutes acceptance of the revised Terms.</p>

      <h2>14. Contact Us</h2>
      <p>
        Questions about these Terms? Email us at <a href="mailto:contact@peak9.in">contact@peak9.in</a>.
      </p>
    </LegalPageLayout>
  );
}
